/**
 * max name character length
 * @type {Number}
 */
export const MAX_NAME_LENGTH = 128;

/**
 * email regex
 * @type {RegExp}
 */
// eslint-disable-next-line security/detect-unsafe-regex
const validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

/**
 * email validation
 * @param  {String} email
 * @return {Boolean}
 */
export const isValidEmailAddress = (email) => email.match(validEmailRegex);

/**
 * @param {Object} options
 * @param {number} [options.max]
 * @param {number} [options.min]
 * @param {number} options.value
 * @returns {Boolean}
 */
export const isBetweenMinAndMax = ({ max, min, value }) => {
  return (typeof min !== 'number' || min <= value) && (typeof max !== 'number' || value <= max);
};

/**
 * name validation (report, people groups, trip groups, etc.)
 * @param  {String} name
 * @return {Boolean}
 */
export const isMaxNameLength = (name) => name !== '' && name?.length > MAX_NAME_LENGTH;

/**
 * Validate that an image does not exceed the maximum width or height.
 * @param {Object} options
 * @param {File} options.file
 * @param {number} options.maxDimensionSize
 * @return {Promise<void>}
 */
export const validateImageDimensions = ({ file, maxDimensionSize }) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    const cleanup = () => URL.revokeObjectURL(objectUrl);

    image.onload = () => {
      cleanup();

      if (image.naturalWidth > maxDimensionSize || image.naturalHeight > maxDimensionSize) {
        reject(
          new Error(`Image dimensions cannot exceed ${maxDimensionSize}x${maxDimensionSize} pixels`)
        );
        return;
      }

      resolve();
    };

    image.onerror = () => {
      cleanup();
      reject(new Error('Unable to read image dimensions'));
    };

    image.src = objectUrl;
  });
};
